<div>
  <p>L'avviso è stato generato con successo. Vuoi scaricarlo ora?</p>
  <div class="row btn-group-row">
      <div class="col-sm-2 col-xs-4">
          <button type="button" aria-label="No" (click)="onAction(false)" class="btn btn-danger btn-block">No</button>
      </div>
      <div class="col-sm-8 col-xs-3"></div>
      <div class="col-sm-2 col-xs-4">
          <button type="button" aria-label="Sì" (click)="onAction(true)" class="btn btn-primary btn-block">Sì</button>
      </div>
  </div>
</div>

